import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
  selectCompanyEnrollmentInformation,
  selectNaviagtionFromOnboarding,
  updateNavigationFromOnboarding,
} from '../../store/slices/onboardingSlice';
import ContentHome from './Content/ContentHome';
import { HomePage } from './Home/HomePage';
import { useOptimizelyFlag } from '../../common/hooks/useOptimizelyFlag';
import { EdgeHomeNewDesignFlag } from '../../common/OptimizelyFlagsConstants';

export function Dashboard() {
  const dispatch = useAppDispatch();
  const companyEnrollmentInformation = useAppSelector(selectCompanyEnrollmentInformation);
  const navigationFromOnboarding = useAppSelector(selectNaviagtionFromOnboarding);
  const {
    decision: edgeHomeNewDesignDecision,
    isDecisionReady: isEdgeHomeNewDesignDecisionReady,
    loaderComponent: edgeHomeNewDesignLoaderComponent,
  } = useOptimizelyFlag({ flag: EdgeHomeNewDesignFlag });

  useEffect(() => {
    if (navigationFromOnboarding && companyEnrollmentInformation?.status) {
      dispatch(updateNavigationFromOnboarding(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyEnrollmentInformation, navigationFromOnboarding]);

  if (!isEdgeHomeNewDesignDecisionReady) return edgeHomeNewDesignLoaderComponent;

  return edgeHomeNewDesignDecision?.enabled ? <HomePage /> : <ContentHome/>;
}
